var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings" } },
    [
      _c("v-app", [
        _c(
          "div",
          { staticClass: "settings-card padded" },
          [_c("vo-settings-profile")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-card padded" },
          [_c("vo-settings-password")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-card padded" },
          [_c("vo-settings-email")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-card padded" },
          [_c("vo-settings-notifications")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-card" },
          [_c("vo-settings-notifications-schedule")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47aa12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47aa12d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 569
// module chunks = 4